package com.essntl.uikit.components.input.date

import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Shape
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.VisualTransformation
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.datepicker.EsDateRangePickerDialog
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsLargeIcon
import core.dateformat.domain.DateFormatUseCase
import core.validation.EsInputState
import org.koin.compose.koinInject

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun EsDateRangeInput(
    value: String,
    onValueChange: (String) -> Unit,
    fromDate: String,
    toDate: String,
    onDateRangeChange: (String, String) -> Unit,
    label: String? = null,
    message: String? = null,
    prefix: @Composable (() -> Unit)? = null,
    enabled: Boolean = true,
    readOnly: Boolean = !enabled,
    state: EsInputState = EsInputState.Default,
    visualTransformation: VisualTransformation = VisualTransformation.None,
    keyboardOptions: KeyboardOptions =
        KeyboardOptions.Default.copy(
            keyboardType = KeyboardType.Decimal,
            autoCorrectEnabled = false,
        ),
    keyboardActions: KeyboardActions = KeyboardActions.Default,
    singleLine: Boolean = false,
    maxLines: Int = if (singleLine) 1 else Int.MAX_VALUE,
    minLines: Int = 1,
    interactionSource: MutableInteractionSource = remember { MutableInteractionSource() },
    cursorColor: Color = Color.Unspecified,
    shape: Shape = RoundedCornerShape(12.dp),
    modifier: Modifier = Modifier,
) {
    var isDatePickerExpanded by remember { mutableStateOf(false) }

    val dateFormatUseCase = koinInject<DateFormatUseCase>()

    EsDateInputCore(
        value = if (value.contains("-"))
            dateFormatUseCase.formatDate(value.split("-")[0]) + " - " + dateFormatUseCase.formatDate(value.split("-")[1])
        else if (!value.contains("/"))
            dateFormatUseCase.formatDate(value) else
            value,
        onValueChange = onValueChange,
        dateFormat = dateFormatUseCase.getDateFormat(),
        label = label,
        message = message,
        prefix = prefix,
        suffix = {
            EsLargeIcon(
                res = EsIcons.Calendar,
                modifier =
                    Modifier
                        .clip(CircleShape)
                        .pointerHoverIcon(PointerIcon.Hand)
                        .clickable(
                            interactionSource = remember { MutableInteractionSource() },
                            indication = null,
                            enabled = enabled,
                        ) {
                            isDatePickerExpanded = true
                        },
            )
        },
        enabled = enabled,
        readOnly = readOnly,
        focusable = !value.contains("-"),
        state = state,
        visualTransformation = visualTransformation,
        keyboardOptions = keyboardOptions,
        keyboardActions = keyboardActions,
        singleLine = singleLine,
        maxLines = maxLines,
        minLines = minLines,
        interactionSource = interactionSource,
        cursorColor = cursorColor,
        shape = shape,
        modifier = modifier,
    )

    EsDateRangePickerDialog(
        isExpanded = isDatePickerExpanded,
        onDismissRequest = { isDatePickerExpanded = false },
        fromDate = fromDate,
        toDate = toDate,
        onDateRangeChange = onDateRangeChange,
    )
}
